export default __webpack_public_path__ + "static/media/icon-query.3e94d1b4.svg";